import BlogTopPicks from "./BlogTopPicks";
export default BlogTopPicks;
